import React, {useState} from 'react';
import {actionsState as projectState} from "../Redux/project";
import {actionsState as modulesState} from "../Redux/modules";
import {useDispatch} from "react-redux";
import {sendReselectEvent} from "../Helpers/Events";
import {getStrLang} from "../Helpers/functions";
const WallMenu = ({wall,remove,cutWall})=>{

    const dispatch = useDispatch();

    const _addWindow = ()=>{
        wall.addObject('window');
        sendReselectEvent(document.querySelector('#plan'));
    }
    const _addDoor = ()=>{
        wall.addObject('door');
        sendReselectEvent(document.querySelector('#plan'));
    }

    const showModuleInfo = ()=>{
        dispatch(projectState.setModal('wallInfo'))
    }

    return <div className="objectMenu">
        <div className="objectMenu-inner">
            <div className="objectMenu__item" onClick={()=>{showModuleInfo()}}>
                <div className="tooltip tooltip-bottom">{ getStrLang('c3d_iIypX') }</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path d="M26,41.22H24a3,3,0,0,1-3-3v-.69a12.88,12.88,0,0,1-2-.84l-.48.49a3,3,0,0,1-4.23,0l-1.44-1.44a3,3,0,0,1,0-4.23L13.3,31a12.88,12.88,0,0,1-.84-2h-.69a3,3,0,0,1-3-3V24a3,3,0,0,1,3-3h.69a12.88,12.88,0,0,1,.84-2l-.49-.48a3,3,0,0,1,0-4.23l1.44-1.44a3,3,0,0,1,4.23,0l.48.49a12.88,12.88,0,0,1,2-.84v-.69a3,3,0,0,1,3-3h2a3,3,0,0,1,3,3v.69a12.88,12.88,0,0,1,2,.84l.48-.49a3,3,0,0,1,4.23,0l1.44,1.44a3,3,0,0,1,0,4.23L36.7,19a12.88,12.88,0,0,1,.84,2h.69a3,3,0,0,1,3,3v2a3,3,0,0,1-3,3h-.69a12.88,12.88,0,0,1-.84,2l.49.48a3,3,0,0,1,0,4.23l-1.44,1.44a3,3,0,0,1-4.23,0L31,36.7a12.88,12.88,0,0,1-2,.84v.69A3,3,0,0,1,26,41.22ZM19.28,34.7a11.49,11.49,0,0,0,2.9,1.21,1,1,0,0,1,.72.92v1.4A1.08,1.08,0,0,0,24,39.32h2a1.08,1.08,0,0,0,1.08-1.09v-1.4a1,1,0,0,1,.72-.92,11.49,11.49,0,0,0,2.9-1.21.94.94,0,0,1,1.15.15l1,1a1.08,1.08,0,0,0,1.53,0l1.44-1.44a1.08,1.08,0,0,0,0-1.53l-1-1a.94.94,0,0,1-.15-1.15,11.49,11.49,0,0,0,1.21-2.9,1,1,0,0,1,.92-.72h1.4A1.08,1.08,0,0,0,39.32,26V24a1.08,1.08,0,0,0-1.09-1.08h-1.4a1,1,0,0,1-.92-.72,11.49,11.49,0,0,0-1.21-2.9.94.94,0,0,1,.15-1.15l1-1a1.08,1.08,0,0,0,0-1.53L34.4,14.16a1.08,1.08,0,0,0-1.53,0l-1,1a.94.94,0,0,1-1.15.15,11.49,11.49,0,0,0-2.9-1.21,1,1,0,0,1-.72-.92v-1.4A1.08,1.08,0,0,0,26,10.68H24a1.08,1.08,0,0,0-1.08,1.09v1.4a1,1,0,0,1-.72.92,11.49,11.49,0,0,0-2.9,1.21.94.94,0,0,1-1.15-.15l-1-1a1.08,1.08,0,0,0-1.53,0L14.16,15.6a1.08,1.08,0,0,0,0,1.53l1,1a.94.94,0,0,1,.15,1.15,11.49,11.49,0,0,0-1.21,2.9,1,1,0,0,1-.92.72h-1.4A1.08,1.08,0,0,0,10.68,24v2a1.08,1.08,0,0,0,1.09,1.08h1.4a1,1,0,0,1,.92.72,11.49,11.49,0,0,0,1.21,2.9.94.94,0,0,1-.15,1.15l-1,1a1.08,1.08,0,0,0,0,1.53l1.44,1.44a1.08,1.08,0,0,0,1.53,0l1-1a.94.94,0,0,1,1.15-.15Z"/>
                        <path d="M25,32.06A7.06,7.06,0,1,1,32.06,25,7.07,7.07,0,0,1,25,32.06Zm0-12.22A5.16,5.16,0,1,0,30.16,25,5.17,5.17,0,0,0,25,19.84Z"/>
                    </g>
                </svg>
            </div>
            <div className="objectMenu__item" onClick={()=>{cutWall(wall)}}>
                <div className="tooltip tooltip-bottom">{ getStrLang('c3d_xdw6H') }</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <g fill="currentColor">
                        <line x1="13.75" y1="13.75" x2="36.25" y2="36.25"/>
                        <rect x="24.25" y="9.09" width="1.5" height="31.82" transform="translate(-10.36 25) rotate(-45)"/>
                        <circle cx="13.75" cy="13.75" r="3.75"/>
                        <path d="M13.75,18A4.25,4.25,0,1,1,18,13.75,4.26,4.26,0,0,1,13.75,18Zm0-7.5A3.25,3.25,0,1,0,17,13.75,3.26,3.26,0,0,0,13.75,10.5Z"/>
                        <circle cx="36.25" cy="36.25" r="3.75"/>
                        <path d="M36.25,40.5a4.25,4.25,0,1,1,4.25-4.25A4.26,4.26,0,0,1,36.25,40.5Zm0-7.5a3.25,3.25,0,1,0,3.25,3.25A3.26,3.26,0,0,0,36.25,33Z"/>
                        <circle cx="24.87" cy="25" r="5"/>
                        <path d="M24.87,30.75A5.75,5.75,0,1,1,30.62,25,5.76,5.76,0,0,1,24.87,30.75Zm0-10A4.25,4.25,0,1,0,29.12,25,4.25,4.25,0,0,0,24.87,20.75Z"/>
                    </g>
                </svg>
            </div>
            {wall.canAddObject('window') && (
                <div className="objectMenu__item" onClick={()=>{_addWindow()}}>
                    <div className="tooltip tooltip-bottom">{ getStrLang('c3d_AhH1H') }</div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                        <g fill="currentColor">
                            <path d="M23.5,8h-12a1,1,0,0,0-1,1V26a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1V9A1,1,0,0,0,23.5,8Zm-1,6H18.45V10H22.5Zm-6.05-4v4H12.5V10ZM12.5,16h3.95v9H12.5Zm5.95,9V16H22.5v9Z"/>
                        </g>
                    </svg>
                </div>
            )}
            {wall.canAddObject('door') && (
                <div className="objectMenu__item" onClick={()=>{_addDoor()}}>
                    <div className="tooltip tooltip-bottom">{ getStrLang('c3d_By2L8') }</div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                        <g fill="currentColor">
                            <path d="M23.5,27h-12a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V26A1,1,0,0,1,23.5,27Zm-11-2h10V10h-10Z"/>
                            <path d="M19.72,18.93a1.86,1.86,0,1,1,1.86-1.86A1.85,1.85,0,0,1,19.72,18.93Z"/>
                        </g>
                    </svg>
                </div>
            )}
            <div className="objectMenu__item" onClick={()=>{remove(wall)}}>
                <div className="tooltip tooltip-bottom">{ getStrLang('c3d_z4jZa') }</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
                    <g fill="currentColor">
                        <path d="M34.82,13.35H29.68v-.93a2.81,2.81,0,0,0-2.81-2.81H23.13a2.81,2.81,0,0,0-2.81,2.81v.93H15.18a2.34,2.34,0,0,0-2.34,2.34V19a.93.93,0,0,0,.93.93h.51l.81,17a2.81,2.81,0,0,0,2.81,2.67H32.1a2.81,2.81,0,0,0,2.81-2.67l.81-17h.51a.93.93,0,0,0,.93-.93V15.69a2.34,2.34,0,0,0-2.34-2.34Zm-12.63-.93a.94.94,0,0,1,.94-.94h3.74a.94.94,0,0,1,.94.94v.93H22.19Zm-7.48,3.27a.47.47,0,0,1,.47-.47H34.82a.47.47,0,0,1,.47.47V18H14.71ZM33,36.79a.94.94,0,0,1-.94.89H17.9a.94.94,0,0,1-.94-.89l-.8-16.89H33.84Z"/>
                        <path d="M25,35.81a.94.94,0,0,0,.94-.94V22.71a.94.94,0,0,0-1.88,0V34.87A.94.94,0,0,0,25,35.81Z"/>
                        <path d="M29.68,35.81a.94.94,0,0,0,.93-.94V22.71a.94.94,0,1,0-1.87,0V34.87A.94.94,0,0,0,29.68,35.81Z"/>
                        <path d="M20.32,35.81a.94.94,0,0,0,.94-.94V22.71a.94.94,0,1,0-1.87,0V34.87A.94.94,0,0,0,20.32,35.81Z"/>
                    </g>
                </svg>
            </div>
        </div>
    </div>

}
export default WallMenu;
